export default __webpack_public_path__ + "static/step_12-7a9557839017e3748edaa2d8cca42201.png";